<!--
 * @Descripttion: 
 * @version: 
 * @Author: lfs
 * @Date: 2022年03月30日 12:09:43
-->
<template>
  <div class="edit-list atb-flex atb-flex-column">
    <div class="atb-content-bg atb-flex atb-flex-column">
      <div class="search">
        <el-form :inline="true" :model="searchParam" class="atb-input" @keyup.enter.native.prevent="getList(1)" @submit.native.prevent>
          <el-form-item class="flex-form-item" label="部门名称" prop="departmentNo">
            <el-popover placement="bottom-start" width="420" popper-class="popper-tree declare-dep" @hide="handledHide" trigger="click">
              <el-tree
                :props="defaultProps"
                :data="treeData"
                show-checkbox
                node-key="id"
                ref="tree"
                highlight-current
                check-strictly
                :default-expanded-keys="expandedData"
                :filter-node-method="filterDeptNode"
                @check-change="handleCheckChange"
              >
              </el-tree>
              <el-input slot="reference" v-model="department" placeholder="请选择部门名称" clearable></el-input>
            </el-popover>
          </el-form-item>
          <el-form-item label="人员姓名">
            <selecter v-model="searchParam.WkName"></selecter>
          </el-form-item>
          <!-- <el-form-item label="日期">
            <el-date-picker
              v-model="searchParam.Date"
              value-format="yyyy-MM-dd"
              align="right"
              type="date"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item> -->
          <el-form-item label="日期">
            <el-date-picker
              v-model="searchParam.FinishDate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <!-- <el-form-item label="">
            <el-checkbox v-model="searchParam.isSub">直属下级</el-checkbox>
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" @click="getList(1)">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="add" @click="showPatchHandler">补填</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-content atb-flex atb-flex-column">
        <vxe-table
          class="atb-table header-table edit-table"
          border="inner"
          height="100%"
          auto-resize
          resizable
          stripe
          highlight-hover-row
          highlight-current-row
          :data="tableData"
          ref="executeForm"
        >
          <vxe-table-column type="seq" width="60" title="序号"></vxe-table-column>
          <vxe-table-column field="wkNo" width="80" title="工号"></vxe-table-column>
          <vxe-table-column field="wkName" width="150" title="姓名"></vxe-table-column>
          <vxe-table-column field="department" min-width="220" title="部门"></vxe-table-column>
          <vxe-table-column field="title" min-width="250" title="执行表格">
            <template #default="{ row }">
              <span class="table-link" @click.stop="openTable(row)">{{ row.title }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="" title="操作" fixed width="180" class-name="operation">
            <template #default="scope">
              <div>
                <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                  <i class="icon-close delete" v-throttle @click.stop="deleteWork(scope.row)"></i>
                </el-tooltip>
              </div>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div class="page-con atb-flex atb-flex-justify-end">
        <vxe-pager
          background
          :current-page.sync="page.PageIndex"
          :page-size.sync="page.PageSize"
          :total="total"
          height="100%"
          @page-change="handlePageChange"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Total']"
        >
        </vxe-pager>
      </div>
    </div>
    <el-dialog title="补填" :visible.sync="showPatch" v-if="showPatch" width="500px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div>
        <el-form :model="patchForm" :rules="patchRules" ref="form" label-width='80px' label-position="right">
          <el-form-item label="指定人" prop="resWkNo">
            <selecter v-model="patchForm.resWkNo" class="patch-item"></selecter>
          </el-form-item>
          <el-form-item label="类型" prop="type">
            <el-select clearable v-model="patchForm.type" placeholder="类型" class="patch-item">
              <el-option v-for="item in patchTypes" :key="item.id" :label="item.value" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="补填日期" prop="patchDate">
            <el-date-picker
              v-model="patchForm.patchDate"
              type="date"
              placeholder="选择日期"
              :picker-options="pickerOptions"
              class="patch-item">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="insertPatchEvent">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showPatch = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import XEUtils from 'xe-utils';
import _ from 'lodash';
export default {
  components: {
    selecter: () => import('@/component/global/customerSelect'),
  },
  name: 'executeForm',
  data() {
    return {
      searchParam: {
        Week: null,
        Status: null,
        Key: null,
        isSub: true,
        FinishDate: '',
      },
      page: {
        PageIndex: 1,
        PageSize: 10,
      },
      category: {
        day: '日',
        week: '周',
        month: '月',
        year: '年',
      },
      total: 0,
      tableData: [],
      that: this,
      expandedData: [],
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      depList: [],
      department: '',
      departmentNo: '',

      showPatch: false,
      patchForm: {},
      patchTypes: [{id: 1, value: '年'}, {id: 2, value: '月'}, {id: 2, value: '周'}],
      patchRules: {
        resWkNo: [{ required: true, message: '请选择指定人', trigger: 'change' }],
        type: [{ required: true, message: '请选择类型', trigger: 'change' }],
        patchDate: [{ required: true, message: '请选择补填日期', trigger: 'change' }],
      },
      pickerOptions: {
        disabledDate(time) {
          return false;
        }
      },
      isDynamicEffective: true,
    };
  },
  computed: {},
  created() {
    this.getVersionConfig();
  },
  mounted() {
    this.getDep();
    this.getList(1);
  },
  methods: {
    getVersionConfig() {
      this.$ajax.get(this.$api.common.getYearPlanConfig).then((res) => {
        if (!res.data || res.data.length === 0) {
          this.isDynamicEffective = false;
        }
      });
    },
    getList(page) {
      this.page.PageIndex = page;
      const queryWhere = _.cloneDeep(this.searchParam);
      if (queryWhere.FinishDate && queryWhere.FinishDate.length > 0) {
        queryWhere.StartTime = this.formatDate(this.searchParam.FinishDate[0], 'yyyy-MM-dd');
        queryWhere.EndTime = this.formatDate(this.searchParam.FinishDate[1], 'yyyy-MM-dd');
        delete queryWhere.FinishDate;
      }
      const pageParam = { SkipCount: (this.page.PageIndex - 1) * this.page.PageSize, MaxResultCount: this.page.PageSize };
      let param = Object.assign({ department: this.departmentNo }, queryWhere, pageParam);
      this.$ajax.get(this.$api.workManage.list, param).then((res) => {
        this.tableData = res.data.rows;
        this.total = res.data.total;
      });
    },
    async getDep() {
      await this.$ajax.get(this.$api.Identity.Categord.dep, {}).then((res) => {
        this.depList = res.data || [];
        const obj = {};
        this.depList.forEach((v) => {
          const objClone = _.cloneDeep(obj);
          (objClone.id = v.id), (objClone.code = v.code), (objClone.label = v.displayName);
          if (v.parentId === null) {
            this.expandedData.push(v.id);
            objClone.children = this.depList.filter((t) => t.parentId === v.id);
            this.generateMenu(objClone.children);
            this.treeData.push(objClone);
            this.copyTreeData = _.cloneDeep(this.treeData);
          }
        });
      });
    },
    generateMenu(chs) {
      chs.forEach((v) => {
        v.label = v.displayName;
        v.children = this.depList.filter((t) => t.parentId === v.id);
        this.generateMenu(v.children);
      });
    },
    handleCheckChange(data, checked) {
      if (checked === true) {
        this.checkId = data.id;
        this.departmentNo = data.code;
        this.department = data.label;
        this.$refs.tree.setCheckedKeys([data.id]);
      } else {
        if (this.checkId === data.id) {
          this.checkId = '';
          this.departmentNo = '';
          this.department = '';
          this.$refs.tree.setCheckedKeys([]);
        }
      }
    },
    getChildrenMenu(depData) {
      let depTree = [];
      depData.forEach((t) => {
        if (t.label.indexOf(this.department) != -1) {
          depTree.push(t);
        } else {
          if (t.children && t.children && t.children.length) {
            t.children = this.getChildrenMenu(t.children);
            if (t.children && t.children.length) {
              depTree.push(t);
            }
          }
        }
      });
      return (this.treeData = depTree);
    },
    filterDeptNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    foldHistoryTree() {
      let treeList = this.treeData;
      //关键代码
      for (let i = 0; i < treeList.length; i++) {
        this.$refs.tree.store.nodesMap[treeList[i].id].expanded = false;
      }
    },
    handledHide() {
      this.$nextTick(() => {
        if (!this.$refs.tree.getCheckedKeys().length) {
          this.department = '';
        }
      });
    },
    formatDate(value, format) {
      return XEUtils.toDateString(value, format);
    },
    handlePageChange({ currentPage }) {
      this.getList(currentPage);
    },
    exportExcel() {
      this.$ajax
        .get(this.$api.export.executeFormListTaskExport, this.searchParam)
        .then((res) => {
          if (res.code === 0) {
            this.$router.push({
              path: '/manage/export-task/index',
            });
          }
        })
        .catch(() => {});
    },
    goDetail({ row }) {
      console.log(row);
      this.$router.push({
        path: '/personal/year-plan/detail',
        query: {
          id: row.id,
          status: row.status,
        },
      });
    },
    filterData(res) {
      return res && res.data && res.data.rows;
    },
    openTable(row) {
      if (row.category === 'year') {
        if (this.isDynamicEffective && (row.version || (row.status == 0 || row.status == 30))) {
          this.$router.push({
            path: '/manage/edit-plan/year-next',
            query:{
              id: row.workId,
            }
          });
        } else {
          this.$router.push({
            path: '/manage/edit-plan/year',
            query:{
              id: row.workId,
            }
          });
        }
      } else if (row.category === 'month') {
        this.$router.push({
          path: '/manage/edit-plan/month',
          query: {
            id: row.workId,
          },
        });
      } else if (row.category === 'week') {
        this.$router.push({
          path: '/manage/edit-plan/week',
          query: {
            id: row.workId,
          },
        });
      } else if (row.category === 'day') {
        this.$router.push({
          path: '/manage/edit-plan/day',
          query: {
            id: row.workId,
          },
        });
      }
    },
    deleteWork(row) {
      this.$confirm('确定要删除吗', '删除', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        closeOnClickModal: false,
        closeOnPressEscape: false,
      }).then(() => {
        let reqUrl = '';
        if (row.category === 'year') {
          reqUrl = this.$api.workManage.year.deleteList;
        } else if (row.category === 'month') {
          reqUrl = this.$api.workManage.month.deleteList;
        } else if (row.category === 'week') {
          reqUrl = this.$api.workManage.week.deleteList;
        } else if (row.category === 'day') {
          reqUrl = this.$api.workManage.day.deleteList;
        }
        this.$ajax.delete(`${reqUrl}/${row.workId}`).then(() => {
          this.$message.success('删除成功');
          this.getList(this.page.PageIndex);
        });
      });
    },
    // 补填
    showPatchHandler() {
      this.showPatch = true;
      this.patchForm = {};
    },
    async insertPatchEvent() {
      this.$refs["form"].validate(valid=>{
        //通过后提交数据
        if(valid){
          const patchDate = this.formatDate(this.patchForm.patchDate, 'yyyy-MM-dd');
          this.$ajax.post(this.$api.workManage.patch, { resWkNo: this.patchForm.resWkNo, type: this.patchForm.type, patchDate }).then(() => {
            this.getList(this.page.PageIndex);
            this.$message.success(`补填成功`);
          }).finally(()=>{
            this.showPatch = false;
          });
        }
      });
    },
  },
  activated() {},
  watch: {
    department: {
      handler(val) {
        this.$refs.tree && this.$refs.tree.filter(val);
        if (!val) {
          this.departmentNo = "";
          if (this.$refs.tree) {
            setTimeout(() => {
              const depTree = _.cloneDeep(this.copyTreeData);
              this.treeData = depTree;
            }, 10)
            this.$refs.tree.setCheckedKeys([]);
          }
        }
      },
    },
  },
};
</script>
<style scoped lang="scss">
.edit-list {
  height: 100%;
  .search {
    .el-date-editor--daterange {
      width: 360px;
    }
  }
  .atb-content-bg {
    margin-top: 0px;
    padding: 20px;
    flex: 1;
  }
  ::v-deep .el-tag {
    padding: 0 8px;
    width: auto;
  }
  .plan_table {
    padding: 0 5px;
  }
  .el-link--danger {
    cursor: auto;
  }
}
.patch-item {
  width: 100%;
  ::v-deep .el-input__inner {
    border-radius: 4px;
  }
}
.footer {
  text-align: right;
  margin-top: 20px;
  .select-all-program {
    margin-right: 20px;
  }
}
.declare-dep {
  height: 350px;
  width: 350px;
  overflow: auto;
}
</style>
